import styled from 'styled-components';

export const TopBar = styled.div<{
  $isBulkActionsEnabled?: boolean;
  detailView?: boolean;
}>`
  width: 100%;
  display: flex;
  align-items: center;
  ${({ $isBulkActionsEnabled }) =>
    $isBulkActionsEnabled
      ? 'column-gap: 5px'
      : 'justify-content: space-between;'}
  ${({ detailView }) =>
    detailView &&
    `
    border-top: 1px solid var(--color-smoke-50);
    background-color: #f5f7f9;
    height: 56px;
    border-bottom: 1px #cfd7df solid;
    padding: 0 15px;
    box-shadow: 0 2px 4px 0 rgb(24 50 71 / 8%);
    position: sticky;
    z-index: 10;
    top: 0px;
  `}

  div.filter-view-popover-anchor {
    position: absolute;
    top: 30px;
    left: 50px;
  }

  .custom-tag {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 2px 8px;
    gap: 10px;
    background: #e5f2fd;
    border: 1px solid #bbdcfe;
    border-radius: 4px;
    font-weight: 600;
    font-size: 12px;
    line-height: 20px;
    color: #2c5cc5;
  }

  .left {
    display: flex;
    position: relative;
    align-items: center;
    margin-right: 15px;
    button {
      margin-left: 0;
      margin-right: 8px;
      width: 28px;
      padding: 0 6px;
      height: 28px;
    }
    .hamburger {
      height: 26px;
      padding: 4px;
      cursor: pointer;

      &:hover {
        background: var(--bg-info);
        border-radius: 4px;
      }
    }
    h5 {
      margin-bottom: 0;
    }
    .title {
      display: flex;
      align-items: center;
      h5 {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 0;
        text-overflow: ellipsis;
        max-width: 450px;
        overflow: hidden;
        white-space: nowrap;
      }
      .response-id {
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        color: var(--base-color);
      }
    }
  }
  .pagination-actions {
    display: flex;
    align-items: center;
    .pagination-prev-next-container {
      display: flex;
      .pagination-text:not(:last-child) {
        border-right: 1px solid var(--color-smoke-100);
      }
    }
    button {
      margin: 0;
      padding: 6px 10px 6px 10px;
      width: 100%;
      display: block;
      cursor: pointer;
      line-height: 1.5;
      text-align: center;
      font-weight: 500;
      letter-spacing: 0.3px;
      border-radius: 4px;
      white-space: nowrap;
      user-select: none;
      background-color: #ffffff;
      border: 1px solid #cfd7df;
      font-size: 14px;
      background-image: linear-gradient(180deg, #ffffff 2.56%, #f5f7f9 95.75%);
      box-shadow: 0 1px 0 0 rgb(24 50 71 / 5%);
      color: #12344d;
      height: 34px;
      &:disabled {
        box-shadow: none;
        background-image: linear-gradient(180deg, #ebeff3 0%, #ebeff3 100%);
        border: 1px solid #cfd7df;
        color: #92a2b1;
        cursor: not-allowed;
      }
    }

    .pagination-text {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      text-align: right;
      color: #264966;
      padding: 0 15px;
    }
  }
  .right {
    display: flex;
    padding: 0 15px;
    margin-left: auto;
  }
  .btn-survey-route {
    width: auto;
    display: flex;
    align-items: center;
    margin: 0 15px 0 0px;
    padding: 4px 15px;
    cursor: pointer;
    line-height: 1.5;
    text-align: center;
    font-weight: 500;
    -webkit-letter-spacing: 0.3px;
    -moz-letter-spacing: 0.3px;
    -ms-letter-spacing: 0.3px;
    letter-spacing: 0.3px;
    border-width: 1px;
    border-style: solid;
    border-radius: 4px;
    white-space: nowrap;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: #ffffff;
    border-color: #cfd7df;
    font-size: 14px;
    background-image: linear-gradient(180deg, #ffffff 0%, #f5f7f9 100%);
    box-shadow: 0 1px 0 0 rgba(24, 50, 71, 0.05);
    color: #12344d;
    height: 34px;
    svg {
      margin-right: 6px;
    }
  }
`;

export const Header = styled.div`
  background: var(--color-milk);
  position: sticky;
  z-index: 9;
  top: 0px;

  .content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px 5px;
  }

  span.label {
    padding: 8px 20px;
    font-size: 14px;
    font-weight: 500;
  }
`;

export const ResponseContainer = styled.div`
  width: 100%;
  display: flex;
  height: calc(100% - 56px);
  position: relative;

  .empty {
    margin: 50px auto;
    text-align: center;
    color: var(--secondary-color);
  }

  .response-view {
    display: flex;
    flex-direction: column;
    position: relative;
    background: white;
    flex: 1;
    overflow-y: auto;

    &__body {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: auto;
    }

    .response-action-header {
      width: 100%;
      overflow: auto;
      min-height: 86px;
      width: 100%;
      display: flex;
      align-items: center;
      padding: 0 26px;
      z-index: 1;
      background: #fff;
      flex-direction: row;
      button:first-child {
        margin-left: 0;
      }

      button.option {
        padding-right: 4px !important;
        padding-left: 12px !important;
      }

      button {
        display: flex;
        align-items: center;
      }
    }

    .button-skeleton {
      margin-right: 16px;
    }

    .container {
      flex: 1;
      overflow: auto;
      display: flex;
      position: relative;
      flex-direction: column;
      padding: 0 26px;

      .profile-icon {
        min-width: 35px;
        min-height: 35px;
        background: #c4bee3;
        border-radius: 38px;
        font-weight: 600;
        font-size: 18px;
        color: #fff;
        line-height: 35px;
        text-align: center;
        margin-right: 10px;
      }
    }

    ::-webkit-scrollbar {
      height: 6px;
      width: 6px;
    }
    ::-webkit-scrollbar-track {
      background: rgba(255, 255, 255, 0.1);
    }
    ::-webkit-scrollbar-thumb {
      background: rgba(216, 216, 216, 0.5);
      border-radius: 5px;
    }
  }

  .contact-info {
    padding: 25px;
    width: 300px;
    border-left: 1px solid #cfd7df;
    background: #f5f7f9;

    .title {
      font-size: 14px !important;
      color: var(--base-color) !important;
    }

    .heading {
      font-weight: 600;
      font-size: 12px;
      line-height: 30px;
      text-transform: uppercase;
      color: var(--secondary-color);
    }

    .row {
      margin-bottom: 18px;
      margin-top: 12px;
      .content {
        font-size: 14px;
        color: var(--base-color);
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .default-loader {
    display: flex;
    align-items: center;
    width: 100%;
  }
`;

export const ResponseWrapper = styled.div`
  background: var(--color-milk);
  min-height: 100%;
  width: 400px;
  min-width: 400px;
  box-shadow: 4px -3px 6px 1px #ebeff3a8;
  z-index: 9;

  .header {
    display: flex;
    width: 100%;
    padding: 12px 10px 0;
    border-bottom: 1px solid var(--color-smoke-50);
    background: var(--color-milk);

    div[role='tablist'] {
      justify-content: space-between;

      > div {
        font-size: 14px;
      }
    }
  }
  .title {
    display: flex;
    align-items: center;
    margin-bottom: 14px;

    h5 {
      margin-bottom: 0;
      padding: 0 10px;
    }
  }

  .container {
    padding: 0;
    padding-bottom: 8px;
    overflow: auto;
    height: 100%;
  }

  .loadnew {
    margin: 10px auto;
    width: auto;
    display: block;
    padding: 4px 15px;
    cursor: pointer;
    font-weight: 500;
    letter-spacing: 0.3px;
    border: 1px solid #cfd7df;
    border-radius: 4px;
    background-color: #fff;
    font-size: 14px;
    background-image: linear-gradient(#fff 0%, #f5f7f9 100%);
    box-shadow: #1832470d 0px 1px 0px 0px;
    color: #12344d;
    height: 34px;
  }
`;

export const ResponseTable = styled.div`
  height: 100%;
  width: 100%;
  table {
    border-radius: 4px;
    overflow: hidden;
  }
  .fui-table {
    display: flex;
    height: 100%;
    flex-direction: column;
  }
  .table-actions {
    z-index: 1100;
    min-height: 58px;
    margin: 0 !important;
  }

  .table-wrapper {
    overflow: auto;
    padding: unset;
    margin: 10px;

    th:first-child {
      border-top-left-radius: 5px;
    }
    th:last-child {
      border-top-right-radius: 5px;
    }
    tr:last-child {
      border-radius: 5px;
      td:first-child {
        border-bottom-left-radius: 5px;
      }
      td:last-child {
        border-bottom-right-radius: 5px;
      }
    }
  }
  .table-content {
    overflow: auto;
    height: 100%;
  }
  .table-filters {
    padding: 0;
  }

  tbody {
    td:first-child {
      max-width: 350px;
    }
  }
  tfoot {
    position: fixed;
    bottom: 0;
    z-index: 10;
    td {
      background-color: unset !important;
      padding: 0 !important;
      max-width: 100% !important;
    }
    .table-pagination {
      button:first-child,
      button:last-child {
        display: none;
      }
    }
  }
  th {
    font-size: 12px;
    font-weight: 600;
    padding: 12px 12px;
    text-align: left;
    .table-checkbox {
    }
  }
  td {
    max-width: 256px;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 12px 12px;
    white-space: nowrap;
    .table-checkbox {
      padding-left: 12px;
    }
  }

  .recipient {
    display: flex;
    flex-direction: column;
    .name {
      margin-bottom: 4px;
      display: flex;
      .contact-name {
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: var(--base-color);
        max-width: 150px;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .contact-id {
        font-weight: 400;
        font-size: 12px !important;
        line-height: 20px;
        color: #475867;
        margin-left: 10px;
      }
    }
    .channel {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: #475867;
    }
  }

  .comment {
    display: flex;
    align-items: center;
    color: var(--text-link);
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    .text {
      max-width: 200px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;

export const BulkActionsContainer = styled.div`
  display: flex;
  button {
    padding: 4px 13px 5px;
    font-size: 14px;
    display: flex;
    align-items: center;
    column-gap: 5px;
    height: 34px;
  }
  ul {
    margin: 5px !important;
  }
`;
